
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'crm-index-ui',
  currentProjectVersion: 'static-2.46663',
  depVersions: {
  "crm-index-ui": "static-2.46663",
  "ably-hubspot-js": "static-1.435",
  "apollo-dlb": "static-3.41",
  "apollo-stack-hubspot": "static-3.43",
  "billing-management-service-client": "static-1.3157",
  "calling-orchestration-shared-library": "static-1.29689",
  "card-associated-objects-lib": "static-1.38211",
  "card-associated-objects-lib-legacy": "static-1.5828",
  "client-types": "static-1.372",
  "commerce-contract-lib": "static-1.5596",
  "commerce-products-lib": "static-1.4378",
  "commerce-shared-components-lib": "static-1.14300",
  "commerce-tools-ui-lib": "static-1.6119",
  "commerce-tours-lib": "static-1.3216",
  "contextual-settings-lib": "static-1.1631",
  "credit-memos-ui-lib": "static-1.5753",
  "crm_data": "static-4.86290",
  "crm-cards-global-registry": "static-1.14276",
  "crm-common-dlb": "static-1.3987",
  "crm-component-utils": "static-1.34086",
  "crm-index-associations-lib": "static-1.5046",
  "crm-index-visualization-core": "static-1.2571",
  "crm-legacy-global-containers": "static-1.22458",
  "crm-legacy-links": "static-1.71176",
  "crm-message-bus": "static-1.36124",
  "crm-object-board-core": "static-1.12252",
  "crm-object-gantt": "static-1.2281",
  "crm-object-map": "static-1.1638",
  "crm-object-search-query-utilities": "static-1.6000",
  "crm-object-search-query-utilities-test-utils": "static-1.5661",
  "crm-pipeline-board-settings-lib": "static-1.25293",
  "crm-pipelines-api-client-types": "static-1.3021",
  "customer-data-bulk-actions": "static-1.29547",
  "customer-data-objects": "static-1.6275",
  "customer-data-objects-ui-components": "static-1.11547",
  "customer-data-properties": "static-1.45175",
  "customer-data-sidebar": "static-2.40416",
  "customer-data-views-management": "static-1.21874",
  "data-fetching-client": "static-1.8290",
  "data-privacy-hub-settings-service-types": "static-1.2867",
  "demographics-client": "static-1.4079",
  "dispatcher": "static-1.111",
  "embedded-academy-lib": "static-1.9801",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.299",
  "external-options-client-types": "static-1.2970",
  "feedback-loader": "static-1.26316",
  "foundations-components": "static-1.5839",
  "foundations-components-test-utils": "static-1.3324",
  "foundations-theming": "static-1.2982",
  "foundations-theming-specialty": "static-1.699",
  "framework-data-schema-quick-fetch": "static-1.5439",
  "framework-data-schema-resolvers": "static-1.5534",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.6991",
  "framework-data-table": "static-2.8342",
  "general-store": "static-6.20",
  "googlemaps-react-wrapper": "static-1.3",
  "growth-onboarding-beacon": "static-1.2331",
  "growth-payments-core": "static-1.20666",
  "head-dlb": "static-1.3878",
  "highcharts": "static-8.80",
  "history": "static-4.47",
  "hs-promise-utils": "static-1.4194",
  "hs-test-utils": "static-1.6656",
  "hub-http": "static-1.4807",
  "hubspot-apollo-client": "static-1.3496",
  "hubspot-dlb": "static-2.1371",
  "HubStyleTokens": "static-2.10164",
  "I18n": "static-7.1379",
  "immer": "static-1.33",
  "immutable": "static-2.19",
  "inbound-db-meta-service-client": "static-1.2671",
  "inbound-db-properties-service-client": "static-1.2816",
  "inbounddb-objects-service-types": "static-1.3105",
  "jasmine-immutable": "static-1.1635",
  "jasmine-runner": "static-1.5071",
  "laboratory-lib": "static-3.5923",
  "lodash": "static-1.3",
  "marketing-event-attendance-cards-ui": "static-1.4761",
  "marketplace-embed": "static-1.15894",
  "marketplace-ui-client-types": "static-1.11019",
  "object-builder-ui-client": "static-1.41408",
  "onboarding-data-sync-lib": "static-1.44",
  "onboarding-scopes": "static-1.5224",
  "onboarding-tours": "static-1.14008",
  "payments-zero-states-lib": "static-1.14135",
  "pipeline-validation-client-types": "static-1.2759",
  "PortalIdParser": "static-2.277",
  "products-iframe-lib": "static-1.2427",
  "products-ui-components": "static-1.34898",
  "property-management-iframe": "static-1.7828",
  "quartz": "static-1.5419",
  "quick-fetch": "static-1.2869",
  "raven": "static-3.4615",
  "react": "static-7.151",
  "react-dlb": "static-1.51",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-4.5",
  "react-redux": "static-7.16",
  "react-rhumb": "static-1.15255",
  "react-router-dom": "static-5.26",
  "react-utils": "static-2.4211",
  "recording-review-components-lib": "static-1.25993",
  "reference-resolvers-lite": "static-1.6638",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.7051",
  "reporting-data": "static-1.61122",
  "reporting-dlb": "static-1.54040",
  "reporting-testing-lib": "static-1.3057",
  "reporting-visualizations": "static-1.53199",
  "sales-views-client-types": "static-1.3016",
  "self-service-api": "static-1.8857",
  "settings-ui-lib": "static-1.11226",
  "signup-constants": "static-1.15937",
  "styled-components": "static-2.63",
  "superstore": "static-1.3438",
  "svh-onboarding-config-shared-lib": "static-1.2094",
  "tinymce": "static-6.5",
  "transmute": "static-2.29",
  "trial-components-library": "static-1.10665",
  "ui-addon-draggable": "static-2.1196",
  "ui-addon-integrations-directory-panel": "static-2.6659",
  "ui-addon-upgrades": "static-9.15832",
  "ui-components-test-utils": "static-1.4303",
  "UIComponents": "static-3.7112",
  "usage-based-billing-components-lib": "static-1.3151",
  "usage-tracker-core": "static-1.5982",
  "user-context": "static-1.3838",
  "webpack-env": "static-1.54",
  "wootric-nps": "static-1.5623",
  "account-and-billing-components": "static-1.16195",
  "account-and-billing-fintech-outages": "static-3.14945",
  "accounting-extension-card-ui": "static-1.30949",
  "accounting-integrations-ui-components": "static-1.4658",
  "ai-components-ui-library": "static-1.5032",
  "apollo-link-hub-http": "static-2.3456",
  "attribution-sidebar-cards": "static-1.38595",
  "BizOpsCrmUIComponents": "static-1.40122",
  "call-widget-addon": "static-2.27121",
  "calling-integration-sdk-support": "static-1.25209",
  "calling-integration-timeline-event": "static-1.12909",
  "calling-internal-common": "static-1.29880",
  "calling-lifecycle-internal": "static-1.58395",
  "calling-ui-library": "static-1.64314",
  "card-biz-ops-customer-success-lib": "static-1.71269",
  "card-biz-ops-domain-controls-lib": "static-1.71270",
  "card-biz-ops-related-contacts-lib": "static-1.71269",
  "card-crm-attribution-lib": "static-1.49528",
  "card-deal-collaborators-lib": "static-1.32330",
  "card-deal-shared-view-lib": "static-1.63228",
  "card-engagement-attachments-lib": "static-1.67521",
  "card-gdpr-subscriptions-card-lib": "static-1.41565",
  "card-integration-card-lib": "static-1.67541",
  "card-linked-in-sales-navigator-lib": "static-1.35228",
  "card-lists-lib": "static-1.65586",
  "card-past-conversations-lib": "static-1.31981",
  "card-payment-history-lib": "static-1.31125",
  "card-playbooks-lib": "static-1.57815",
  "card-preview-highlight-lib": "static-1.69791",
  "card-profile-products-lib": "static-1.51304",
  "card-profile-quotes-lib": "static-1.78487",
  "card-properties-lib": "static-1.38305",
  "card-sales-activities-timeline": "static-1.32497",
  "card-target-account-lib": "static-1.67241",
  "card-website-activity-lib": "static-1.68049",
  "chatspot-widget-iframe": "static-1.14933",
  "collaboration-sidebar": "static-1.51777",
  "commerce-billing-lib": "static-1.14247",
  "commerce-subscription-cards-lib": "static-1.25531",
  "commerce-subscription-lib": "static-1.30706",
  "composer-plugins": "static-1.66321",
  "conversations-thread-view-crm-events": "static-1.28995",
  "copilot-toolkit": "static-1.5759",
  "credit-memos-iframe-lib": "static-1.5755",
  "crm_components": "static-3.86290",
  "crm_schema": "static-3.86327",
  "crm_ui": "static-5.86248",
  "crm_universal": "static-1.20407",
  "crm-activity-creator-interaction-window": "static-1.40214",
  "crm-activity-creator-interactions-legacy": "static-1.30683",
  "crm-activity-creator-widgets": "static-1.46265",
  "crm-associations-table": "static-1.35935",
  "crm-cards": "static-1.38845",
  "crm-cards-sdk": "static-1.37548",
  "crm-command-handler": "static-1.30192",
  "crm-display-components": "static-1.19836",
  "crm-events-components": "static-1.54956",
  "crm-events-data": "static-1.54969",
  "crm-fe-perf": "static-1.21666",
  "crm-index-ui-toolbar": "static-1.1807",
  "crm-index-view-table-edit-columns-modal": "static-1.15538",
  "crm-index-visualization-toolbar": "static-1.2232",
  "crm-index-visualization-toolbar-test-utils": "static-1.1603",
  "crm-links": "static-1.4761",
  "crm-object-board": "static-1.22173",
  "crm-object-board-card": "static-1.12248",
  "crm-object-preview": "static-1.20876",
  "crm-object-table": "static-1.17044",
  "crm-timeline": "static-1.83295",
  "crm-timeline-tasks": "static-1.32214",
  "cropperjs": "static-1.10",
  "cssUtils": "static-1.467",
  "customer-data-board": "static-1.19270",
  "customer-data-board-card": "static-1.19231",
  "customer-data-bulk-actions-container": "static-1.15258",
  "customer-data-communicator": "static-1.39719",
  "customer-data-email": "static-1.15580",
  "customer-data-filters-ui": "static-1.33260",
  "customer-data-property-utils": "static-1.6593",
  "customer-data-reference-ui-components": "static-1.11645",
  "customer-data-rte": "static-1.28577",
  "customer-data-ui-utilities": "static-1.8396",
  "deal-registration-ui": "static-1.29665",
  "deal-splits-cards-ui": "static-1.39124",
  "deal-splits-sidebar": "static-1.39030",
  "draft-email-branding-plugin": "static-2.19842",
  "draft-js": "static-5.37",
  "draft-plugins": "static-2.19066",
  "draft-signature-plugin": "static-1.19603",
  "email-confirm-ui": "static-2.4304",
  "EmailSignatureEditor": "static-1.20184",
  "ExportDialog": "static-6.9059",
  "ExtensionInstallHelpers": "static-1.529",
  "file-manager-components": "static-1.17911",
  "FileManagerLib": "static-1.33552",
  "flywheel-feedback-panel-components": "static-1.5950",
  "foundations-assets": "static-1.3581",
  "framework-app-settings-features-lib": "static-1.3711",
  "frontend-preferences-client": "static-1.6542",
  "getting-started-shared-tasks": "static-1.11707",
  "graphql": "static-1.58",
  "growth-data-modal": "static-1.3877",
  "growth-feature-usage-components": "static-1.4222",
  "growth-feature-usage-data": "static-1.4441",
  "growth-onboarding-empty-states": "static-1.3839",
  "HeadJS": "static-2.567",
  "hubspot-prosemirror": "static-1.13195",
  "hubspot-url-utils": "static-1.3028",
  "HubStyle": "static-2.10473",
  "icons": "static-2.591",
  "in-meeting-experience-ui-components": "static-1.16568",
  "InboxConnectUtils": "static-4.9320",
  "integration-settings-components": "static-1.10193",
  "integrations-directory-panel-lib": "static-1.7549",
  "invoices-card-lib": "static-1.51199",
  "invoices-iframe-lib": "static-1.51128",
  "invoices-ui-lib": "static-1.49070",
  "lead-tracking-lib": "static-1.33400",
  "marketing-contacts-lib": "static-1.7809",
  "marketing-contacts-ui": "static-1.6308",
  "marketing-event-cards-ui": "static-1.31359",
  "marketplace-ui-apps-core": "static-1.12149",
  "marketplace-ui-common": "static-1.13613",
  "metrics-js": "static-1.8417",
  "mobile-manifest-mixins": "static-1.338",
  "native-integrations-shared-strings": "static-1.6501",
  "nav-meta": "static-1.25215",
  "object-comments-thread-lib": "static-1.5701",
  "onboarding-tours-client": "static-1.3168",
  "orders-card-lib": "static-1.16484",
  "panel-deal-registration-ai-summary-lib": "static-1.22164",
  "partner-shared-view-ui": "static-1.41917",
  "playbooks-modal": "static-1.74988",
  "playlists-lib": "static-1.6503",
  "products-highlight-card-lib": "static-1.12663",
  "property-translator": "static-1.4056",
  "quartz-core": "static-1.4638",
  "quotes-ui-lib": "static-1.73679",
  "react-beautiful-dnd": "static-1.13",
  "react-colorpicker": "static-2.8907",
  "react-immutable-render-mixin": "static-1.9",
  "react-select-plus": "static-1.65",
  "recent-activities-card": "static-1.52820",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "redux-toolkit": "static-1.7",
  "reference-resolvers": "static-1.6820",
  "reporting-action-components": "static-1.35689",
  "reporting-crm-object-table": "static-1.2290",
  "reporting-enablement": "static-1.16486",
  "reporting-ui-components": "static-2.58400",
  "reselect": "static-2.16",
  "rich-text-lib": "static-1.17218",
  "rpc-client-utils": "static-1.3386",
  "SalesContentIndexUI": "static-3.6904",
  "salesforce-sync-card-ui": "static-1.7612",
  "sanitize-text": "static-1.6848",
  "sequences-lib": "static-1.5725",
  "SharedI18nStrings": "static-1.162",
  "subscriptions-components": "static-1.40863",
  "svh-conversations-settings-lib": "static-1.2094",
  "tasks-lib": "static-1.32288",
  "timezone-utils": "static-2.3918",
  "transcript-sidebar": "static-1.62050",
  "trellis-ecosystem": "static-1.4371",
  "ui-addon-avatars": "static-2.8098",
  "ui-addon-form-validation": "static-1.9688",
  "ui-addon-i18n": "static-1.9592",
  "ui-addon-iframeable": "static-1.7558",
  "ui-addon-opt": "static-4.7330",
  "ui-addon-react-router-dom": "static-1.8279",
  "ui-addon-scriptloader": "static-1.11057",
  "ui-addon-teams": "static-1.19577",
  "ui-asset-management-lib": "static-1.8873",
  "ui-business-units-lib": "static-1.7538",
  "ui-gdpr-components": "static-1.8916",
  "ui-shepherd-react": "static-3.8719",
  "ui-universal-auth": "static-1.7460",
  "usage-tracker": "static-1.6132",
  "usage-tracker-container": "static-1.6122",
  "atom": "static-1.3901",
  "hs-lodash": "static-4.45",
  "planout": "static-5.12",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "sanitize": "static-1.3054",
  "hs-promise-rejection-tracking": "static-1.4156",
  "raven-hubspot": "static-1.4922",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.2336",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.1696",
  "quartz-webpack": "static-1.1643",
  "ably": "static-1.18",
  "calling-orchestration-schema": "static-1.29914",
  "avatar-components": "static-1.1085",
  "calling-global-api": "static-1.57013",
  "campaigns-lib": "static-1.21693",
  "card-payment-highlight-lib": "static-1.31260",
  "customer-data-tracking": "static-1.5467",
  "payment-link-components": "static-1.18049",
  "payments-embed-points-lib": "static-1.9045",
  "persist-promise": "static-1.2416",
  "PatternValidationJS": "static-1.437",
  "usage-tracker-session-replay": "static-1.2954",
  "utility-belt": "static-1.1236",
  "products-ui-components-shared-msw-handlers": "static-1.7290",
  "hs-story-utils": "static-1.8063",
  "msw": "static-1.39",
  "payments-enrollment-embed-lib": "static-1.17180",
  "StyleGuideUI": "static-3.455",
  "ui-images": "static-2.809",
  "cv-backend-services": "static-1.1110",
  "growth-onboarding-confetti": "static-1.1778",
  "payments-post-enroll-local-storage-lib": "static-1.3764",
  "prosemirror": "static-1.13",
  "qrcode-generator": "static-1.43",
  "react-dnd-compat": "static-1.3324",
  "magpie-lib": "static-1.4340",
  "magpie-types": "static-1.3800",
  "adobe-sign-cards-lib": "static-1.12703",
  "ai-addon-copilot-preview": "static-1.4244",
  "automation-ui-crm-card-workflows-invoker": "static-1.4758",
  "buyer-intent-card": "static-1.15811",
  "card-call-summaries-lib": "static-1.29849",
  "card-company-summary-lib": "static-1.13466",
  "card-customer-spend-trends-lib": "static-1.20782",
  "card-flywheel-activity-history-lib": "static-1.1947",
  "card-flywheel-company-overview-lib": "static-1.10976",
  "card-flywheel-domain-review-history-lib": "static-1.604",
  "card-flywheel-high-intent-associated-contacts-lib": "static-1.10976",
  "card-guest-access-management-lib": "static-1.2520",
  "card-guided-execution-activities": "static-1.3965",
  "card-knowledge-base-lib": "static-1.6712",
  "card-lead-insights": "static-1.9185",
  "card-lead-qualification-lib": "static-1.24732",
  "card-object-highlight-lib": "static-1.1252",
  "card-object-summary-lib": "static-1.2800",
  "card-other-tickets-lib": "static-1.14987",
  "card-partner-client-portal-usage-outcomes-lib": "static-1.25623",
  "card-partner-client-unified-usage-score-lib": "static-1.19988",
  "card-prospecting-research-agent": "static-1.2073",
  "card-target-account-signals": "static-1.622",
  "card-tasks-timeline-lib": "static-1.9577",
  "card-ticket-summary-lib": "static-1.11424",
  "commerce-billing-engine-lib": "static-1.1066",
  "crm-actions": "static-1.4724",
  "crm-associations-pivot": "static-1.34065",
  "crm-clv-report": "static-1.2723",
  "crm-data-highlights": "static-1.36473",
  "crm-events-viz-cards": "static-1.35715",
  "crm-events-viz-totals": "static-1.27268",
  "crm-extension": "static-1.35793",
  "crm-pipeline-approvals-lib": "static-1.18737",
  "crm-properties-list": "static-1.33111",
  "crm-property-history": "static-1.11171",
  "crm-quick-actions": "static-1.12621",
  "crm-relative-timeline": "static-1.13049",
  "crm-report": "static-1.36680",
  "crm-simple-deadline": "static-1.13267",
  "crm-stage-tracker": "static-1.31644",
  "crm-statistics": "static-1.25689",
  "custom-events-card-lib": "static-1.360",
  "customer-overview-card-lib": "static-1.4303",
  "customer-success-contacts-card-lib": "static-1.12496",
  "deal-summary-components": "static-1.15336",
  "docusign-cards-lib": "static-1.22153",
  "flywheel-growth-plans-crm-card": "static-1.1505",
  "guided-actions-card": "static-1.8946",
  "guided-selling-stage-tracker-card": "static-1.6175",
  "health-score-card-lib": "static-1.15779",
  "help-desk-insights-lib-crm-cards": "static-1.17750",
  "intelligence-overview-card": "static-1.9643",
  "intelligence-overview-lib": "static-1.7853",
  "invoices-history-card-lib": "static-1.25483",
  "lead-scores-card": "static-1.12116",
  "legacy-sidebar-card-lib": "static-1.29328",
  "payment-schedule-card-lib": "static-1.22912",
  "playbooks-card": "static-1.37698",
  "predictive-scores-card": "static-1.25291",
  "process-guide-cards": "static-1.3432",
  "products-cards-lib": "static-1.3971",
  "purchase-history-lib": "static-1.15170",
  "ui-google-drive-attachments": "static-1.1402",
  "ui-google-drive-insights": "static-1.1404",
  "customer-data-properties-shared-msw-handlers": "static-1.6235",
  "ts-schema": "static-1.3022",
  "framework-builder-read-service-client": "static-1.2944",
  "hub-http-shared-msw-handlers": "static-1.6905",
  "multi-currency-client-types": "static-1.2723",
  "customer-data-associations": "static-1.5868",
  "react-virtualized-auto-sizer": "static-1.24",
  "react-window": "static-1.13",
  "task-forms-lib": "static-1.35470",
  "universal-associations-select": "static-1.9453",
  "fast-json-stable-stringify": "static-1.4",
  "csstype": "static-1.38",
  "jasmine": "static-4.3009",
  "usage-tracker-public": "static-1.5943",
  "content-assistance-lib": "static-1.6147",
  "crm-record-access-management-lib": "static-1.20724",
  "customer-data-content": "static-1.24251",
  "draft-content-plugins": "static-1.23920",
  "draft-convert": "static-2.31",
  "draft-extend": "static-2.46",
  "enrichment-properties-lib": "static-1.9171",
  "FireAlarmUi": "static-1.3524",
  "flux-actions": "static-1.268",
  "marketing-contacts-client": "static-1.6309",
  "pipeline-governance-client-types": "static-1.3075",
  "prospecting-agent-lib": "static-1.6449",
  "react-virtualized": "static-2.73",
  "subscriptions-client": "static-1.41103",
  "surveymonkey-crm-card": "static-1.35073",
  "autolinker": "static-3.11",
  "conditional-properties-service-client": "static-1.2806",
  "google-libphonenumber": "static-1.11",
  "calling-error-reporting": "static-1.29886",
  "card-subscription-highlight-lib": "static-1.33129",
  "invoices-highlight-card-lib": "static-1.49055",
  "orders-highlight-card-lib": "static-1.16767",
  "project-storage": "static-1.3358",
  "quotes-highlight-card-lib": "static-1.64968",
  "crm-export-dialog": "static-1.4964",
  "customer-data-filters": "static-1.47075",
  "FormUrlGenerator": "static-2.3392",
  "testing-library": "static-1.120",
  "academy-common-lib": "static-1.9261",
  "bend-plugin-foundations-components": "static-1.2107",
  "floating-ui": "static-1.28",
  "framer-motion": "static-1.40",
  "react-aria": "static-1.38",
  "tanstack-table": "static-1.23",
  "ui-fonts": "static-1.331",
  "bend-plugin-foundations-theming": "static-1.1465",
  "foundations-theming-base": "static-1.1967",
  "smart-property-lib": "static-1.51",
  "growth-onboarding-feedback-components": "static-1.5120",
  "commerce-analytics-service-client": "static-1.2402",
  "hs-test-utils-bend-plugin": "static-1.1767",
  "i18n-data": "static-1.196",
  "moment-timezone": "static-5.51",
  "marketplace-ui-details": "static-1.3513",
  "navigation-components": "static-1.13578",
  "ui-shepherd-tracker": "static-1.6100",
  "property-description-translator": "static-1.2521",
  "property-management-common": "static-1.114",
  "quartz-core-utils": "static-1.2286",
  "call-summary": "static-1.31706",
  "reporting-client-types": "static-1.1787",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.9138",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "conversations-async-data": "static-2.6337",
  "conversations-error-reporting": "static-1.7615",
  "conversations-http": "static-1.3473",
  "conversations-internal-schema": "static-1.11320",
  "conversations-message-history": "static-1.9761",
  "routing-ui": "static-1.15445",
  "hubs-service-types": "static-1.127",
  "salesImages": "static-1.498",
  "trials-service-types": "static-1.2756",
  "react-flip-move": "static-1.46",
  "feature-store-service-types": "static-1.3348",
  "growth-monetization-service-types": "static-1.3355",
  "upgrade-management-service-types": "static-1.3339",
  "hub-http-janus": "static-1.639",
  "subscription-experience-data-types": "static-1.10181",
  "getting-started-shared-tasks-store": "static-1.10825",
  "final-form": "static-1.39",
  "fintech-outages-service-client-types": "static-1.11815",
  "transactions-exp-service-client-types": "static-1.11811",
  "conversations-skeleton-state": "static-1.6051",
  "integrations-lib": "static-1.9943",
  "chatspot-client-types": "static-1.8340",
  "chatspot-core": "static-1.14939",
  "ContentUtils": "static-1.62681",
  "sassPrefix": "static-1.130",
  "report-customization-components": "static-1.8322",
  "reporting-snowflake": "static-1.49743",
  "activity-history-lib": "static-1.1567",
  "assisted-buying-components": "static-1.5700",
  "bet-customer-success-shared-ui": "static-1.11771",
  "company-details-components": "static-1.4576",
  "company-details-service-types": "static-1.2596",
  "flywheel-recent-conversions-lib": "static-1.1237",
  "industries-core": "static-1.5437",
  "payment-method-components": "static-1.5207",
  "quote-checkout-common-lib": "static-1.9067",
  "quote-checkout-service-types": "static-1.2280",
  "calling-client-interface": "static-1.69553",
  "calling-cross-tab-library": "static-1.17847",
  "calling-integration-cross-tab": "static-1.16983",
  "calling-lifecycle-messages": "static-1.50691",
  "calling-lifecycle-usage-tracker": "static-1.4718",
  "calling-usage-tracker": "static-1.5162",
  "conversations-prop-types": "static-1.6091",
  "shared-worker-versioning": "static-1.9734",
  "hubspot-prosemirror-plugins": "static-1.13187",
  "redux-actions": "static-3.7",
  "share-transcript-modal": "static-1.51695",
  "twilio-voice-sdk": "static-1.50",
  "worker-connection-library": "static-1.11301",
  "domain-review-history-lib": "static-1.1646",
  "flywheel-reject-ql-lib": "static-1.1258",
  "SafeStorage": "static-1.3079",
  "ui-partner-confirmation-links-components": "static-1.21344",
  "FileManagerCore": "static-1.33411",
  "crm-activity-creator-data": "static-1.40761",
  "multi-account-crm-panel-lib": "static-1.11728",
  "sequences-crm-lib": "static-1.22765",
  "quotes-modal-lib": "static-1.95636",
  "call-timeline-event": "static-1.50316",
  "crm-events": "static-1.54963",
  "crm-meetings-components-lib": "static-1.21090",
  "svh-tickets-lib": "static-1.13234",
  "composer-data": "static-1.25150",
  "conversations-inbox-message-history": "static-1.29371",
  "conversations-infrastructure": "static-1.7600",
  "conversations-internal-pub-sub": "static-1.14674",
  "conversations-platform": "static-1.3170",
  "conversations-thread-data": "static-1.62331",
  "crm-events-viz-core": "static-1.28059",
  "hubspotter-http": "static-1.3475",
  "react-transition-group": "static-1.7",
  "ui-addon-conversations-settings": "static-2.27104",
  "ui-suspension-banners-lib": "static-1.5090",
  "zorse-crm-components-lib": "static-1.5671",
  "crm-activity-creator-interactions": "static-1.39486",
  "framework-scoring-history-panel-lib": "static-1.9916",
  "MeetingsLib": "static-2.53000",
  "hub-http-contrib": "static-1.1837",
  "task-queues": "static-1.28241",
  "ui-addon-video-player": "static-1.7435",
  "location-customization-utils-lib": "static-1.3552",
  "all-properties-panel-lib": "static-1.2244",
  "crm-events-viz-timeline": "static-1.35723",
  "customer-data-modals": "static-1.3457",
  "merge-modal-lib": "static-1.6278",
  "predictive-scores-panel": "static-1.24293",
  "property-history-panel": "static-1.18977",
  "flywheel-lead-visibility-lib": "static-1.429",
  "crm-source-interpretation-lib": "static-1.3938",
  "partner-shared-messages-lib": "static-1.12713",
  "redux-mock-store": "static-1.8",
  "automation-platform-service-types": "static-1.2096",
  "guided-selling-core": "static-1.4496",
  "sales-execution-components": "static-1.7704",
  "credit-memos-highlight-card-lib": "static-1.5108",
  "breeze-intelligence-kit": "static-1.3872",
  "policy-lib": "static-1.5457",
  "ui-coaching-tips": "static-1.22105",
  "ui-coaching-tips-shared-config": "static-1.22090",
  "analytics_js": "static-1.3227",
  "blueimp-md5": "static-1.8",
  "calling-cross-tab-messaging": "static-1.17844",
  "feedback-schema": "static-1.48085",
  "forms-utils-lib": "static-1.10007",
  "FormsCommonComponents": "static-1.80515",
  "integrations-tracking-lib": "static-1.4159",
  "MeetingsBase": "static-1.54592",
  "outpost": "static-1.3015",
  "partner-poi-timeline-event": "static-1.34497",
  "qualified-leads-embedded-lib": "static-1.42071",
  "quotes-crm-events-lib": "static-1.37056",
  "react-table": "static-1.15",
  "sales-clients-common": "static-1.45107",
  "sequences-client-types-lib": "static-1.5581",
  "sequences-crm-events-lib": "static-1.22568",
  "settings-ui-nav": "static-2.8725",
  "social-components-lib": "static-1.28479",
  "ui-addon-sales-email": "static-1.3880",
  "ui-tour-react": "static-1.10639",
  "urlinator": "static-1.3219",
  "outreach-assistant-email-generation": "static-1.2523",
  "quotes-client-types": "static-1.31047",
  "sales-email-signature-service-client": "static-1.2656",
  "customer-data-filters-ui-msw-helpers": "static-1.15693",
  "signup-ui-lego-core": "static-1.17947",
  "viral-links-lib": "static-1.5545",
  "media-bridge-lib": "static-1.16489",
  "video-data-lib": "static-1.28921",
  "FileManagerImages": "static-1.31062",
  "trellis-story-utils": "static-1.3222",
  "knowledge-content-types": "static-1.7631",
  "ui-addon-emoji-picker": "static-1.8605",
  "in-meeting-experience-client-types": "static-1.13268",
  "content-embed-lib": "static-1.6014",
  "crm-record-cards-service-types": "static-1.2671",
  "remote-ui": "static-1.39",
  "ui-extensions": "static-1.14484",
  "ui-extensions-remote-renderer": "static-1.12077",
  "universal-page-editor-lib": "static-1.1606",
  "developer-experience-shared-components": "static-1.8758",
  "immutable-less": "static-1.3228",
  "ui-extensibility-client-types": "static-1.2853",
  "markdown-it": "static-1.6",
  "hubspotter-http-shared-msw-handlers": "static-1.6903",
  "platform-navigation-bootstrap": "static-1.11078",
  "dashboard-lib": "static-1.75236",
  "share-with-third-party-component-lib": "static-1.7330",
  "data-quality-ui-library": "static-1.7522",
  "html-to-image": "static-1.29",
  "reporting-plugins": "static-1.6525",
  "reporting-reports": "static-1.60806",
  "data-token-picker": "static-1.13900",
  "navigation-messaging": "static-1.2905",
  "attribution-lib": "static-1.37098",
  "campaigns-build-lib": "static-1.7166",
  "marketing-platform-lib": "static-1.5338",
  "growth-onboarding-reliability": "static-1.3827",
  "sales-checkout-service-client": "static-1.2414",
  "amplitude-session-replay-browser": "static-1.6",
  "stripe-embedded-components": "static-1.5009",
  "idb-keyval": "static-1.20",
  "simple-logging-lib": "static-1.1703",
  "integrations-error-boundary-lib": "static-1.7358",
  "ai-settings-ui-library": "static-1.5741",
  "automation-enrollment-service-types": "static-1.2599",
  "crm-cards-test-utils": "static-1.37395",
  "renewal-center-service-types": "static-1.2835",
  "submissions-lib": "static-1.41033",
  "ui-forms-components": "static-1.8002",
  "portal-details-components": "static-1.13519",
  "ui-extensions-plugin-flywheel": "static-1.9018",
  "ui-product-approvals": "static-1.23486",
  "customer-success-client-types": "static-1.14254",
  "sales-enablement-lib": "static-1.11404",
  "sales-leader-insights-components-lib": "static-1.13031",
  "guided-actions-lib": "static-1.14237",
  "framework-scoring-client-types": "static-1.10969",
  "fsm": "static-1.2377",
  "card-bet-associated-companies-lib": "static-1.71248",
  "card-bet-deal-support-requests-lib": "static-1.61989",
  "card-bet-quotes-lib": "static-1.71255",
  "card-deal-splits-lib": "static-1.38510",
  "card-flywheel-ql-summary-lib": "static-1.40135",
  "card-flywheel-recent-conversions-lib": "static-1.40136",
  "card-invoices-lib": "static-1.50639",
  "card-marketing-event-about-lib": "static-1.50421",
  "card-marketing-event-activity-lib": "static-1.50420",
  "card-past-feedback-lib": "static-1.36241",
  "card-prospecting-notes": "static-1.32497",
  "card-qualified-leads-lib": "static-1.71410",
  "card-sfdcsync-lib": "static-1.50491",
  "card-workflows-lib": "static-1.67423",
  "integrations-sync-card-ui": "static-1.21435",
  "partner-poi-crm-card": "static-1.13953",
  "recording-preview-card": "static-1.11342",
  "ui-sales-order-wizard-card": "static-1.26424",
  "predictive-scores-lib-components": "static-1.22688",
  "process-guide-chirp": "static-1.3264",
  "gapi-client-types": "static-1.3",
  "google-picker-types": "static-1.3",
  "ui-google-drive-picker": "static-1.973",
  "deep-diff": "static-1.5",
  "academy-service-client": "static-1.2688",
  "zustand": "static-1.51",
  "marketplace-ui-reviews": "static-1.13572",
  "marketplace-ui-tracking": "static-1.7787",
  "cms-field-types": "static-1.3457",
  "content-icons-ui": "static-1.1867",
  "reporting-datasets-permissions-lib": "static-1.6885",
  "fintech-buying-service-clients": "static-1.2375",
  "account-and-billing-contacts-usage": "static-2.17654",
  "emoji-regex": "static-1.7",
  "signup-ui-full-screen-search": "static-1.10054",
  "billing-payments-client-types": "static-1.2735",
  "buying-experience-components": "static-1.8468",
  "checkout-service-types": "static-1.2823",
  "growth-pro-utils-lib": "static-1.7804",
  "audio-components": "static-1.4296",
  "video-components": "static-1.7273",
  "video-embed": "static-1.29762",
  "conversations-calling-message": "static-1.54094",
  "crm-events-viz-test-utils": "static-1.16680",
  "crm-pipeline-events-ui": "static-1.22128",
  "conversations-routing-lib": "static-1.5748",
  "conversations-visibility-tools": "static-1.4422",
  "data-ops-fullstory": "static-1.4012",
  "re-reselect": "static-1.4",
  "signup-ui-url-generator": "static-2.6715",
  "usage-tracker-anonymous": "static-1.4549",
  "usage-tracker-multi": "static-1.4546",
  "ql-visibility-lib": "static-1.4171",
  "automation-ui-core": "static-2.15361",
  "automation-ui-permissions": "static-1.13723",
  "workspace-components": "static-1.2701",
  "workspace-view-data": "static-1.1276",
  "settings-content-modals": "static-1.39402",
  "forms-ai-lib": "static-1.2078",
  "react-tinymce": "static-1.50079",
  "SharedLegalStrings": "static-1.1298",
  "tinymce-config": "static-2.49205",
  "meetings-client-types": "static-1.2680",
  "messaging-types-lib": "static-1.39770",
  "apps-service-types": "static-1.2816",
  "oauth-service-types": "static-1.2960",
  "platform-infra-nav-components": "static-1.6580",
  "campaign-roi-lib": "static-1.2326",
  "stripe-connect-js": "static-1.37",
  "customer-data-sidebar-test-utils": "static-1.35094",
  "form-builder-ui": "static-1.7761",
  "user-configuration-lib": "static-1.24142",
  "ui-deal-management-components-lib": "static-1.15272",
  "ui-signature-editor": "static-1.13360",
  "immerable": "static-1.2825",
  "social-insights-client-types": "static-1.17384",
  "automation-ui-routing": "static-1.14785",
  "automation-ui-source-apps": "static-1.12507",
  "ui-addon-draggable-compat": "static-2.2931",
  "access-control-lib": "static-1.9124",
  "EmailComponents": "static-1.48463",
  "EmailData": "static-1.47139",
  "redux-less": "static-2.8113",
  "tinymce-themes": "static-1.51175",
  "interframe": "static-3.3471",
  "tinymce-data": "static-1.35290",
  "tinymce-plugins": "static-1.52319",
  "ContentData": "static-1.62757",
  "marketing-email-service-types": "static-1.1414",
  "layout-dnd-components": "static-1.10599",
  "layout-dnd-utils": "static-1.9574",
  "app-users-service-client": "static-1.3719",
  "app-users-service-types": "static-1.3125",
  "framework-listing-lib": "static-2.21892",
  "mini-checkout-client": "static-1.23904",
  "onboarding-utils": "static-1.4027",
  "ContentComponents": "static-2.65638",
  "messaging-editing-lib": "static-1.40034",
  "ui-tool-access": "static-1.8723",
  "automation-ui-types": "static-1.13425",
  "NamespacedHubStyle": "static-2.8117",
  "codemirror": "static-5.69",
  "react-codemirror": "static-1.9278",
  "layout-data-lib": "static-1.7899",
  "framework-listing-lib-shared-msw-handlers": "static-1.6796",
  "touchless-buying-components": "static-1.3122",
  "merchandise-lib": "static-1.223",
  "data-token-views": "static-1.13881",
  "simple-menus-core": "static-1.13395",
  "simple-menus-lib": "static-1.14912",
  "ui-memberships-settings-lib": "static-1.27827",
  "videoconference-integration-components": "static-1.4787",
  "automation-applications-service-types": "static-1.2462",
  "ContentEditorUI": "static-2.71086",
  "short-messages-app-service-client": "static-1.2815",
  "web-interactives-components": "static-1.11296",
  "web-interactives-data": "static-1.11297",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "checkout-sdk": "static-3.20747",
  "upgrade-catalog-service-types": "static-1.2550",
  "seamless-immutable": "static-7.6",
  "backbone": "static-1.6",
  "content-management-data-lib": "static-1.3733",
  "copilot-plugins": "static-1.5732",
  "cta-picker": "static-1.30863",
  "editor-components": "static-1.11681",
  "editor-iframe-lib": "static-1.6981",
  "error-messaging-js": "static-1.3965",
  "pictos": "static-7.159",
  "redux-request-state": "static-1.9252",
  "smart-content-core": "static-1.36806",
  "smart-content-lib": "static-1.37459",
  "social-composer-lib": "static-1.52896",
  "structured-content-lib": "static-1.19719",
  "theme-previewer-lib": "static-1.47406",
  "tinymce-copilot": "static-1.11273",
  "ui-active-theme-content-creator-lib": "static-1.31326",
  "xray-recommendation-lib": "static-1.5762",
  "hub-http-rxjs": "static-1.606",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "jquery": "static-3.6",
  "ai-rendering-library": "static-1.4557",
  "ui-brand-identity-lib": "static-1.7991",
  "fuzzy": "static-1.8",
  "codemirror-dlb": "static-1.52640",
  "redux-undo": "static-1.10",
  "highlight.js": "static-1.45"
},
  depPathPrefixes: {
  "crm-index-ui": "/crm-index-ui/static-2.46663",
  "ably-hubspot-js": "/ably-hubspot-js/static-1.435",
  "apollo-dlb": "/apollo-dlb/static-3.41",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.43",
  "billing-management-service-client": "/billing-management-service-client/static-1.3157",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.29689",
  "card-associated-objects-lib": "/card-associated-objects-lib/static-1.38211",
  "card-associated-objects-lib-legacy": "/card-associated-objects-lib-legacy/static-1.5828",
  "client-types": "/client-types/static-1.372",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.5596",
  "commerce-products-lib": "/commerce-products-lib/static-1.4378",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.14300",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.6119",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.3216",
  "contextual-settings-lib": "/contextual-settings-lib/static-1.1631",
  "credit-memos-ui-lib": "/credit-memos-ui-lib/static-1.5753",
  "crm_data": "/crm_data/static-4.86290",
  "crm-cards-global-registry": "/crm-cards-global-registry/static-1.14276",
  "crm-common-dlb": "/crm-common-dlb/static-1.3987",
  "crm-component-utils": "/crm-component-utils/static-1.34086",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.5046",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.2571",
  "crm-legacy-global-containers": "/crm-legacy-global-containers/static-1.22458",
  "crm-legacy-links": "/crm-legacy-links/static-1.71176",
  "crm-message-bus": "/crm-message-bus/static-1.36124",
  "crm-object-board-core": "/crm-object-board-core/static-1.12252",
  "crm-object-gantt": "/crm-object-gantt/static-1.2281",
  "crm-object-map": "/crm-object-map/static-1.1638",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.6000",
  "crm-object-search-query-utilities-test-utils": "/crm-object-search-query-utilities-test-utils/static-1.5661",
  "crm-pipeline-board-settings-lib": "/crm-pipeline-board-settings-lib/static-1.25293",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3021",
  "customer-data-bulk-actions": "/customer-data-bulk-actions/static-1.29547",
  "customer-data-objects": "/customer-data-objects/static-1.6275",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.11547",
  "customer-data-properties": "/customer-data-properties/static-1.45175",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.40416",
  "customer-data-views-management": "/customer-data-views-management/static-1.21874",
  "data-fetching-client": "/data-fetching-client/static-1.8290",
  "data-privacy-hub-settings-service-types": "/data-privacy-hub-settings-service-types/static-1.2867",
  "demographics-client": "/demographics-client/static-1.4079",
  "dispatcher": "/dispatcher/static-1.111",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.9801",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.299",
  "external-options-client-types": "/external-options-client-types/static-1.2970",
  "feedback-loader": "/feedback-loader/static-1.26316",
  "foundations-components": "/foundations-components/static-1.5839",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.3324",
  "foundations-theming": "/foundations-theming/static-1.2982",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.699",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.5439",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.5534",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.6991",
  "framework-data-table": "/framework-data-table/static-2.8342",
  "general-store": "/general-store/static-6.20",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "growth-onboarding-beacon": "/growth-onboarding-beacon/static-1.2331",
  "growth-payments-core": "/growth-payments-core/static-1.20666",
  "head-dlb": "/head-dlb/static-1.3878",
  "highcharts": "/highcharts/static-8.80",
  "history": "/history/static-4.47",
  "hs-promise-utils": "/hs-promise-utils/static-1.4194",
  "hs-test-utils": "/hs-test-utils/static-1.6656",
  "hub-http": "/hub-http/static-1.4807",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.3496",
  "hubspot-dlb": "/hubspot-dlb/static-2.1371",
  "HubStyleTokens": "/HubStyleTokens/static-2.10164",
  "I18n": "/I18n/static-7.1379",
  "immer": "/immer/static-1.33",
  "immutable": "/immutable/static-2.19",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.2671",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.2816",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3105",
  "jasmine-immutable": "/jasmine-immutable/static-1.1635",
  "jasmine-runner": "/jasmine-runner/static-1.5071",
  "laboratory-lib": "/laboratory-lib/static-3.5923",
  "lodash": "/lodash/static-1.3",
  "marketing-event-attendance-cards-ui": "/marketing-event-attendance-cards-ui/static-1.4761",
  "marketplace-embed": "/marketplace-embed/static-1.15894",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.11019",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.41408",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.44",
  "onboarding-scopes": "/onboarding-scopes/static-1.5224",
  "onboarding-tours": "/onboarding-tours/static-1.14008",
  "payments-zero-states-lib": "/payments-zero-states-lib/static-1.14135",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.2759",
  "PortalIdParser": "/PortalIdParser/static-2.277",
  "products-iframe-lib": "/products-iframe-lib/static-1.2427",
  "products-ui-components": "/products-ui-components/static-1.34898",
  "property-management-iframe": "/property-management-iframe/static-1.7828",
  "quartz": "/quartz/static-1.5419",
  "quick-fetch": "/quick-fetch/static-1.2869",
  "raven": "/raven/static-3.4615",
  "react": "/react/static-7.151",
  "react-dlb": "/react-dlb/static-1.51",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-4.5",
  "react-redux": "/react-redux/static-7.16",
  "react-rhumb": "/react-rhumb/static-1.15255",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-utils": "/react-utils/static-2.4211",
  "recording-review-components-lib": "/recording-review-components-lib/static-1.25993",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.6638",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.7051",
  "reporting-data": "/reporting-data/static-1.61122",
  "reporting-dlb": "/reporting-dlb/static-1.54040",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.3057",
  "reporting-visualizations": "/reporting-visualizations/static-1.53199",
  "sales-views-client-types": "/sales-views-client-types/static-1.3016",
  "self-service-api": "/self-service-api/static-1.8857",
  "settings-ui-lib": "/settings-ui-lib/static-1.11226",
  "signup-constants": "/signup-constants/static-1.15937",
  "styled-components": "/styled-components/static-2.63",
  "superstore": "/superstore/static-1.3438",
  "svh-onboarding-config-shared-lib": "/svh-onboarding-config-shared-lib/static-1.2094",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.29",
  "trial-components-library": "/trial-components-library/static-1.10665",
  "ui-addon-draggable": "/ui-addon-draggable/static-2.1196",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.6659",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.15832",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.4303",
  "UIComponents": "/UIComponents/static-3.7112",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.3151",
  "usage-tracker-core": "/usage-tracker-core/static-1.5982",
  "user-context": "/user-context/static-1.3838",
  "webpack-env": "/webpack-env/static-1.54",
  "wootric-nps": "/wootric-nps/static-1.5623",
  "account-and-billing-components": "/account-and-billing-components/static-1.16195",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.14945",
  "accounting-extension-card-ui": "/accounting-extension-card-ui/static-1.30949",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.4658",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.5032",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.3456",
  "attribution-sidebar-cards": "/attribution-sidebar-cards/static-1.38595",
  "BizOpsCrmUIComponents": "/BizOpsCrmUIComponents/static-1.40122",
  "call-widget-addon": "/call-widget-addon/static-2.27121",
  "calling-integration-sdk-support": "/calling-integration-sdk-support/static-1.25209",
  "calling-integration-timeline-event": "/calling-integration-timeline-event/static-1.12909",
  "calling-internal-common": "/calling-internal-common/static-1.29880",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.58395",
  "calling-ui-library": "/calling-ui-library/static-1.64314",
  "card-biz-ops-customer-success-lib": "/card-biz-ops-customer-success-lib/static-1.71269",
  "card-biz-ops-domain-controls-lib": "/card-biz-ops-domain-controls-lib/static-1.71270",
  "card-biz-ops-related-contacts-lib": "/card-biz-ops-related-contacts-lib/static-1.71269",
  "card-crm-attribution-lib": "/card-crm-attribution-lib/static-1.49528",
  "card-deal-collaborators-lib": "/card-deal-collaborators-lib/static-1.32330",
  "card-deal-shared-view-lib": "/card-deal-shared-view-lib/static-1.63228",
  "card-engagement-attachments-lib": "/card-engagement-attachments-lib/static-1.67521",
  "card-gdpr-subscriptions-card-lib": "/card-gdpr-subscriptions-card-lib/static-1.41565",
  "card-integration-card-lib": "/card-integration-card-lib/static-1.67541",
  "card-linked-in-sales-navigator-lib": "/card-linked-in-sales-navigator-lib/static-1.35228",
  "card-lists-lib": "/card-lists-lib/static-1.65586",
  "card-past-conversations-lib": "/card-past-conversations-lib/static-1.31981",
  "card-payment-history-lib": "/card-payment-history-lib/static-1.31125",
  "card-playbooks-lib": "/card-playbooks-lib/static-1.57815",
  "card-preview-highlight-lib": "/card-preview-highlight-lib/static-1.69791",
  "card-profile-products-lib": "/card-profile-products-lib/static-1.51304",
  "card-profile-quotes-lib": "/card-profile-quotes-lib/static-1.78487",
  "card-properties-lib": "/card-properties-lib/static-1.38305",
  "card-sales-activities-timeline": "/card-sales-activities-timeline/static-1.32497",
  "card-target-account-lib": "/card-target-account-lib/static-1.67241",
  "card-website-activity-lib": "/card-website-activity-lib/static-1.68049",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.14933",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.51777",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.14247",
  "commerce-subscription-cards-lib": "/commerce-subscription-cards-lib/static-1.25531",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.30706",
  "composer-plugins": "/composer-plugins/static-1.66321",
  "conversations-thread-view-crm-events": "/conversations-thread-view-crm-events/static-1.28995",
  "copilot-toolkit": "/copilot-toolkit/static-1.5759",
  "credit-memos-iframe-lib": "/credit-memos-iframe-lib/static-1.5755",
  "crm_components": "/crm_components/static-3.86290",
  "crm_schema": "/crm_schema/static-3.86327",
  "crm_ui": "/crm_ui/static-5.86248",
  "crm_universal": "/crm_universal/static-1.20407",
  "crm-activity-creator-interaction-window": "/crm-activity-creator-interaction-window/static-1.40214",
  "crm-activity-creator-interactions-legacy": "/crm-activity-creator-interactions-legacy/static-1.30683",
  "crm-activity-creator-widgets": "/crm-activity-creator-widgets/static-1.46265",
  "crm-associations-table": "/crm-associations-table/static-1.35935",
  "crm-cards": "/crm-cards/static-1.38845",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.37548",
  "crm-command-handler": "/crm-command-handler/static-1.30192",
  "crm-display-components": "/crm-display-components/static-1.19836",
  "crm-events-components": "/crm-events-components/static-1.54956",
  "crm-events-data": "/crm-events-data/static-1.54969",
  "crm-fe-perf": "/crm-fe-perf/static-1.21666",
  "crm-index-ui-toolbar": "/crm-index-ui-toolbar/static-1.1807",
  "crm-index-view-table-edit-columns-modal": "/crm-index-view-table-edit-columns-modal/static-1.15538",
  "crm-index-visualization-toolbar": "/crm-index-visualization-toolbar/static-1.2232",
  "crm-index-visualization-toolbar-test-utils": "/crm-index-visualization-toolbar-test-utils/static-1.1603",
  "crm-links": "/crm-links/static-1.4761",
  "crm-object-board": "/crm-object-board/static-1.22173",
  "crm-object-board-card": "/crm-object-board-card/static-1.12248",
  "crm-object-preview": "/crm-object-preview/static-1.20876",
  "crm-object-table": "/crm-object-table/static-1.17044",
  "crm-timeline": "/crm-timeline/static-1.83295",
  "crm-timeline-tasks": "/crm-timeline-tasks/static-1.32214",
  "cropperjs": "/cropperjs/static-1.10",
  "cssUtils": "/cssUtils/static-1.467",
  "customer-data-board": "/customer-data-board/static-1.19270",
  "customer-data-board-card": "/customer-data-board-card/static-1.19231",
  "customer-data-bulk-actions-container": "/customer-data-bulk-actions-container/static-1.15258",
  "customer-data-communicator": "/customer-data-communicator/static-1.39719",
  "customer-data-email": "/customer-data-email/static-1.15580",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.33260",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.6593",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.11645",
  "customer-data-rte": "/customer-data-rte/static-1.28577",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.8396",
  "deal-registration-ui": "/deal-registration-ui/static-1.29665",
  "deal-splits-cards-ui": "/deal-splits-cards-ui/static-1.39124",
  "deal-splits-sidebar": "/deal-splits-sidebar/static-1.39030",
  "draft-email-branding-plugin": "/draft-email-branding-plugin/static-2.19842",
  "draft-js": "/draft-js/static-5.37",
  "draft-plugins": "/draft-plugins/static-2.19066",
  "draft-signature-plugin": "/draft-signature-plugin/static-1.19603",
  "email-confirm-ui": "/email-confirm-ui/static-2.4304",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.20184",
  "ExportDialog": "/ExportDialog/static-6.9059",
  "ExtensionInstallHelpers": "/ExtensionInstallHelpers/static-1.529",
  "file-manager-components": "/file-manager-components/static-1.17911",
  "FileManagerLib": "/FileManagerLib/static-1.33552",
  "flywheel-feedback-panel-components": "/flywheel-feedback-panel-components/static-1.5950",
  "foundations-assets": "/foundations-assets/static-1.3581",
  "framework-app-settings-features-lib": "/framework-app-settings-features-lib/static-1.3711",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.6542",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.11707",
  "graphql": "/graphql/static-1.58",
  "growth-data-modal": "/growth-data-modal/static-1.3877",
  "growth-feature-usage-components": "/growth-feature-usage-components/static-1.4222",
  "growth-feature-usage-data": "/growth-feature-usage-data/static-1.4441",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.3839",
  "HeadJS": "/HeadJS/static-2.567",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.13195",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3028",
  "HubStyle": "/HubStyle/static-2.10473",
  "icons": "/icons/static-2.591",
  "in-meeting-experience-ui-components": "/in-meeting-experience-ui-components/static-1.16568",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.9320",
  "integration-settings-components": "/integration-settings-components/static-1.10193",
  "integrations-directory-panel-lib": "/integrations-directory-panel-lib/static-1.7549",
  "invoices-card-lib": "/invoices-card-lib/static-1.51199",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.51128",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.49070",
  "lead-tracking-lib": "/lead-tracking-lib/static-1.33400",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.7809",
  "marketing-contacts-ui": "/marketing-contacts-ui/static-1.6308",
  "marketing-event-cards-ui": "/marketing-event-cards-ui/static-1.31359",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.12149",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.13613",
  "metrics-js": "/metrics-js/static-1.8417",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.338",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.6501",
  "nav-meta": "/nav-meta/static-1.25215",
  "object-comments-thread-lib": "/object-comments-thread-lib/static-1.5701",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.3168",
  "orders-card-lib": "/orders-card-lib/static-1.16484",
  "panel-deal-registration-ai-summary-lib": "/panel-deal-registration-ai-summary-lib/static-1.22164",
  "partner-shared-view-ui": "/partner-shared-view-ui/static-1.41917",
  "playbooks-modal": "/playbooks-modal/static-1.74988",
  "playlists-lib": "/playlists-lib/static-1.6503",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.12663",
  "property-translator": "/property-translator/static-1.4056",
  "quartz-core": "/quartz-core/static-1.4638",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.73679",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "react-colorpicker": "/react-colorpicker/static-2.8907",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "react-select-plus": "/react-select-plus/static-1.65",
  "recent-activities-card": "/recent-activities-card/static-1.52820",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reference-resolvers": "/reference-resolvers/static-1.6820",
  "reporting-action-components": "/reporting-action-components/static-1.35689",
  "reporting-crm-object-table": "/reporting-crm-object-table/static-1.2290",
  "reporting-enablement": "/reporting-enablement/static-1.16486",
  "reporting-ui-components": "/reporting-ui-components/static-2.58400",
  "reselect": "/reselect/static-2.16",
  "rich-text-lib": "/rich-text-lib/static-1.17218",
  "rpc-client-utils": "/rpc-client-utils/static-1.3386",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.6904",
  "salesforce-sync-card-ui": "/salesforce-sync-card-ui/static-1.7612",
  "sanitize-text": "/sanitize-text/static-1.6848",
  "sequences-lib": "/sequences-lib/static-1.5725",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.162",
  "subscriptions-components": "/subscriptions-components/static-1.40863",
  "svh-conversations-settings-lib": "/svh-conversations-settings-lib/static-1.2094",
  "tasks-lib": "/tasks-lib/static-1.32288",
  "timezone-utils": "/timezone-utils/static-2.3918",
  "transcript-sidebar": "/transcript-sidebar/static-1.62050",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.4371",
  "ui-addon-avatars": "/ui-addon-avatars/static-2.8098",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.9688",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.9592",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.7558",
  "ui-addon-opt": "/ui-addon-opt/static-4.7330",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.8279",
  "ui-addon-scriptloader": "/ui-addon-scriptloader/static-1.11057",
  "ui-addon-teams": "/ui-addon-teams/static-1.19577",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.8873",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.7538",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.8916",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.8719",
  "ui-universal-auth": "/ui-universal-auth/static-1.7460",
  "usage-tracker": "/usage-tracker/static-1.6132",
  "usage-tracker-container": "/usage-tracker-container/static-1.6122",
  "atom": "/atom/static-1.3901",
  "hs-lodash": "/hs-lodash/static-4.45",
  "planout": "/planout/static-5.12",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "sanitize": "/sanitize/static-1.3054",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4156",
  "raven-hubspot": "/raven-hubspot/static-1.4922",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2336",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.1696",
  "quartz-webpack": "/quartz-webpack/static-1.1643",
  "ably": "/ably/static-1.18",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.29914",
  "avatar-components": "/avatar-components/static-1.1085",
  "calling-global-api": "/calling-global-api/static-1.57013",
  "campaigns-lib": "/campaigns-lib/static-1.21693",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.31260",
  "customer-data-tracking": "/customer-data-tracking/static-1.5467",
  "payment-link-components": "/payment-link-components/static-1.18049",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.9045",
  "persist-promise": "/persist-promise/static-1.2416",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.2954",
  "utility-belt": "/utility-belt/static-1.1236",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.7290",
  "hs-story-utils": "/hs-story-utils/static-1.8063",
  "msw": "/msw/static-1.39",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.17180",
  "StyleGuideUI": "/StyleGuideUI/static-3.455",
  "ui-images": "/ui-images/static-2.809",
  "cv-backend-services": "/cv-backend-services/static-1.1110",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.1778",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.3764",
  "prosemirror": "/prosemirror/static-1.13",
  "qrcode-generator": "/qrcode-generator/static-1.43",
  "react-dnd-compat": "/react-dnd-compat/static-1.3324",
  "magpie-lib": "/magpie-lib/static-1.4340",
  "magpie-types": "/magpie-types/static-1.3800",
  "adobe-sign-cards-lib": "/adobe-sign-cards-lib/static-1.12703",
  "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.4244",
  "automation-ui-crm-card-workflows-invoker": "/automation-ui-crm-card-workflows-invoker/static-1.4758",
  "buyer-intent-card": "/buyer-intent-card/static-1.15811",
  "card-call-summaries-lib": "/card-call-summaries-lib/static-1.29849",
  "card-company-summary-lib": "/card-company-summary-lib/static-1.13466",
  "card-customer-spend-trends-lib": "/card-customer-spend-trends-lib/static-1.20782",
  "card-flywheel-activity-history-lib": "/card-flywheel-activity-history-lib/static-1.1947",
  "card-flywheel-company-overview-lib": "/card-flywheel-company-overview-lib/static-1.10976",
  "card-flywheel-domain-review-history-lib": "/card-flywheel-domain-review-history-lib/static-1.604",
  "card-flywheel-high-intent-associated-contacts-lib": "/card-flywheel-high-intent-associated-contacts-lib/static-1.10976",
  "card-guest-access-management-lib": "/card-guest-access-management-lib/static-1.2520",
  "card-guided-execution-activities": "/card-guided-execution-activities/static-1.3965",
  "card-knowledge-base-lib": "/card-knowledge-base-lib/static-1.6712",
  "card-lead-insights": "/card-lead-insights/static-1.9185",
  "card-lead-qualification-lib": "/card-lead-qualification-lib/static-1.24732",
  "card-object-highlight-lib": "/card-object-highlight-lib/static-1.1252",
  "card-object-summary-lib": "/card-object-summary-lib/static-1.2800",
  "card-other-tickets-lib": "/card-other-tickets-lib/static-1.14987",
  "card-partner-client-portal-usage-outcomes-lib": "/card-partner-client-portal-usage-outcomes-lib/static-1.25623",
  "card-partner-client-unified-usage-score-lib": "/card-partner-client-unified-usage-score-lib/static-1.19988",
  "card-prospecting-research-agent": "/card-prospecting-research-agent/static-1.2073",
  "card-target-account-signals": "/card-target-account-signals/static-1.622",
  "card-tasks-timeline-lib": "/card-tasks-timeline-lib/static-1.9577",
  "card-ticket-summary-lib": "/card-ticket-summary-lib/static-1.11424",
  "commerce-billing-engine-lib": "/commerce-billing-engine-lib/static-1.1066",
  "crm-actions": "/crm-actions/static-1.4724",
  "crm-associations-pivot": "/crm-associations-pivot/static-1.34065",
  "crm-clv-report": "/crm-clv-report/static-1.2723",
  "crm-data-highlights": "/crm-data-highlights/static-1.36473",
  "crm-events-viz-cards": "/crm-events-viz-cards/static-1.35715",
  "crm-events-viz-totals": "/crm-events-viz-totals/static-1.27268",
  "crm-extension": "/crm-extension/static-1.35793",
  "crm-pipeline-approvals-lib": "/crm-pipeline-approvals-lib/static-1.18737",
  "crm-properties-list": "/crm-properties-list/static-1.33111",
  "crm-property-history": "/crm-property-history/static-1.11171",
  "crm-quick-actions": "/crm-quick-actions/static-1.12621",
  "crm-relative-timeline": "/crm-relative-timeline/static-1.13049",
  "crm-report": "/crm-report/static-1.36680",
  "crm-simple-deadline": "/crm-simple-deadline/static-1.13267",
  "crm-stage-tracker": "/crm-stage-tracker/static-1.31644",
  "crm-statistics": "/crm-statistics/static-1.25689",
  "custom-events-card-lib": "/custom-events-card-lib/static-1.360",
  "customer-overview-card-lib": "/customer-overview-card-lib/static-1.4303",
  "customer-success-contacts-card-lib": "/customer-success-contacts-card-lib/static-1.12496",
  "deal-summary-components": "/deal-summary-components/static-1.15336",
  "docusign-cards-lib": "/docusign-cards-lib/static-1.22153",
  "flywheel-growth-plans-crm-card": "/flywheel-growth-plans-crm-card/static-1.1505",
  "guided-actions-card": "/guided-actions-card/static-1.8946",
  "guided-selling-stage-tracker-card": "/guided-selling-stage-tracker-card/static-1.6175",
  "health-score-card-lib": "/health-score-card-lib/static-1.15779",
  "help-desk-insights-lib-crm-cards": "/help-desk-insights-lib-crm-cards/static-1.17750",
  "intelligence-overview-card": "/intelligence-overview-card/static-1.9643",
  "intelligence-overview-lib": "/intelligence-overview-lib/static-1.7853",
  "invoices-history-card-lib": "/invoices-history-card-lib/static-1.25483",
  "lead-scores-card": "/lead-scores-card/static-1.12116",
  "legacy-sidebar-card-lib": "/legacy-sidebar-card-lib/static-1.29328",
  "payment-schedule-card-lib": "/payment-schedule-card-lib/static-1.22912",
  "playbooks-card": "/playbooks-card/static-1.37698",
  "predictive-scores-card": "/predictive-scores-card/static-1.25291",
  "process-guide-cards": "/process-guide-cards/static-1.3432",
  "products-cards-lib": "/products-cards-lib/static-1.3971",
  "purchase-history-lib": "/purchase-history-lib/static-1.15170",
  "ui-google-drive-attachments": "/ui-google-drive-attachments/static-1.1402",
  "ui-google-drive-insights": "/ui-google-drive-insights/static-1.1404",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.6235",
  "ts-schema": "/ts-schema/static-1.3022",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.2944",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.6905",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.2723",
  "customer-data-associations": "/customer-data-associations/static-1.5868",
  "react-virtualized-auto-sizer": "/react-virtualized-auto-sizer/static-1.24",
  "react-window": "/react-window/static-1.13",
  "task-forms-lib": "/task-forms-lib/static-1.35470",
  "universal-associations-select": "/universal-associations-select/static-1.9453",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "csstype": "/csstype/static-1.38",
  "jasmine": "/jasmine/static-4.3009",
  "usage-tracker-public": "/usage-tracker-public/static-1.5943",
  "content-assistance-lib": "/content-assistance-lib/static-1.6147",
  "crm-record-access-management-lib": "/crm-record-access-management-lib/static-1.20724",
  "customer-data-content": "/customer-data-content/static-1.24251",
  "draft-content-plugins": "/draft-content-plugins/static-1.23920",
  "draft-convert": "/draft-convert/static-2.31",
  "draft-extend": "/draft-extend/static-2.46",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.9171",
  "FireAlarmUi": "/FireAlarmUi/static-1.3524",
  "flux-actions": "/flux-actions/static-1.268",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.6309",
  "pipeline-governance-client-types": "/pipeline-governance-client-types/static-1.3075",
  "prospecting-agent-lib": "/prospecting-agent-lib/static-1.6449",
  "react-virtualized": "/react-virtualized/static-2.73",
  "subscriptions-client": "/subscriptions-client/static-1.41103",
  "surveymonkey-crm-card": "/surveymonkey-crm-card/static-1.35073",
  "autolinker": "/autolinker/static-3.11",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.2806",
  "google-libphonenumber": "/google-libphonenumber/static-1.11",
  "calling-error-reporting": "/calling-error-reporting/static-1.29886",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.33129",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.49055",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.16767",
  "project-storage": "/project-storage/static-1.3358",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.64968",
  "crm-export-dialog": "/crm-export-dialog/static-1.4964",
  "customer-data-filters": "/customer-data-filters/static-1.47075",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.3392",
  "testing-library": "/testing-library/static-1.120",
  "academy-common-lib": "/academy-common-lib/static-1.9261",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2107",
  "floating-ui": "/floating-ui/static-1.28",
  "framer-motion": "/framer-motion/static-1.40",
  "react-aria": "/react-aria/static-1.38",
  "tanstack-table": "/tanstack-table/static-1.23",
  "ui-fonts": "/ui-fonts/static-1.331",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1465",
  "foundations-theming-base": "/foundations-theming-base/static-1.1967",
  "smart-property-lib": "/smart-property-lib/static-1.51",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.5120",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.2402",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.1767",
  "i18n-data": "/i18n-data/static-1.196",
  "moment-timezone": "/moment-timezone/static-5.51",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.3513",
  "navigation-components": "/navigation-components/static-1.13578",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.6100",
  "property-description-translator": "/property-description-translator/static-1.2521",
  "property-management-common": "/property-management-common/static-1.114",
  "quartz-core-utils": "/quartz-core-utils/static-1.2286",
  "call-summary": "/call-summary/static-1.31706",
  "reporting-client-types": "/reporting-client-types/static-1.1787",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.9138",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "conversations-async-data": "/conversations-async-data/static-2.6337",
  "conversations-error-reporting": "/conversations-error-reporting/static-1.7615",
  "conversations-http": "/conversations-http/static-1.3473",
  "conversations-internal-schema": "/conversations-internal-schema/static-1.11320",
  "conversations-message-history": "/conversations-message-history/static-1.9761",
  "routing-ui": "/routing-ui/static-1.15445",
  "hubs-service-types": "/hubs-service-types/static-1.127",
  "salesImages": "/salesImages/static-1.498",
  "trials-service-types": "/trials-service-types/static-1.2756",
  "react-flip-move": "/react-flip-move/static-1.46",
  "feature-store-service-types": "/feature-store-service-types/static-1.3348",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.3355",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.3339",
  "hub-http-janus": "/hub-http-janus/static-1.639",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.10181",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.10825",
  "final-form": "/final-form/static-1.39",
  "fintech-outages-service-client-types": "/fintech-outages-service-client-types/static-1.11815",
  "transactions-exp-service-client-types": "/transactions-exp-service-client-types/static-1.11811",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6051",
  "integrations-lib": "/integrations-lib/static-1.9943",
  "chatspot-client-types": "/chatspot-client-types/static-1.8340",
  "chatspot-core": "/chatspot-core/static-1.14939",
  "ContentUtils": "/ContentUtils/static-1.62681",
  "sassPrefix": "/sassPrefix/static-1.130",
  "report-customization-components": "/report-customization-components/static-1.8322",
  "reporting-snowflake": "/reporting-snowflake/static-1.49743",
  "activity-history-lib": "/activity-history-lib/static-1.1567",
  "assisted-buying-components": "/assisted-buying-components/static-1.5700",
  "bet-customer-success-shared-ui": "/bet-customer-success-shared-ui/static-1.11771",
  "company-details-components": "/company-details-components/static-1.4576",
  "company-details-service-types": "/company-details-service-types/static-1.2596",
  "flywheel-recent-conversions-lib": "/flywheel-recent-conversions-lib/static-1.1237",
  "industries-core": "/industries-core/static-1.5437",
  "payment-method-components": "/payment-method-components/static-1.5207",
  "quote-checkout-common-lib": "/quote-checkout-common-lib/static-1.9067",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.2280",
  "calling-client-interface": "/calling-client-interface/static-1.69553",
  "calling-cross-tab-library": "/calling-cross-tab-library/static-1.17847",
  "calling-integration-cross-tab": "/calling-integration-cross-tab/static-1.16983",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.50691",
  "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.4718",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.5162",
  "conversations-prop-types": "/conversations-prop-types/static-1.6091",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.9734",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.13187",
  "redux-actions": "/redux-actions/static-3.7",
  "share-transcript-modal": "/share-transcript-modal/static-1.51695",
  "twilio-voice-sdk": "/twilio-voice-sdk/static-1.50",
  "worker-connection-library": "/worker-connection-library/static-1.11301",
  "domain-review-history-lib": "/domain-review-history-lib/static-1.1646",
  "flywheel-reject-ql-lib": "/flywheel-reject-ql-lib/static-1.1258",
  "SafeStorage": "/SafeStorage/static-1.3079",
  "ui-partner-confirmation-links-components": "/ui-partner-confirmation-links-components/static-1.21344",
  "FileManagerCore": "/FileManagerCore/static-1.33411",
  "crm-activity-creator-data": "/crm-activity-creator-data/static-1.40761",
  "multi-account-crm-panel-lib": "/multi-account-crm-panel-lib/static-1.11728",
  "sequences-crm-lib": "/sequences-crm-lib/static-1.22765",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.95636",
  "call-timeline-event": "/call-timeline-event/static-1.50316",
  "crm-events": "/crm-events/static-1.54963",
  "crm-meetings-components-lib": "/crm-meetings-components-lib/static-1.21090",
  "svh-tickets-lib": "/svh-tickets-lib/static-1.13234",
  "composer-data": "/composer-data/static-1.25150",
  "conversations-inbox-message-history": "/conversations-inbox-message-history/static-1.29371",
  "conversations-infrastructure": "/conversations-infrastructure/static-1.7600",
  "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.14674",
  "conversations-platform": "/conversations-platform/static-1.3170",
  "conversations-thread-data": "/conversations-thread-data/static-1.62331",
  "crm-events-viz-core": "/crm-events-viz-core/static-1.28059",
  "hubspotter-http": "/hubspotter-http/static-1.3475",
  "react-transition-group": "/react-transition-group/static-1.7",
  "ui-addon-conversations-settings": "/ui-addon-conversations-settings/static-2.27104",
  "ui-suspension-banners-lib": "/ui-suspension-banners-lib/static-1.5090",
  "zorse-crm-components-lib": "/zorse-crm-components-lib/static-1.5671",
  "crm-activity-creator-interactions": "/crm-activity-creator-interactions/static-1.39486",
  "framework-scoring-history-panel-lib": "/framework-scoring-history-panel-lib/static-1.9916",
  "MeetingsLib": "/MeetingsLib/static-2.53000",
  "hub-http-contrib": "/hub-http-contrib/static-1.1837",
  "task-queues": "/task-queues/static-1.28241",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.7435",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.3552",
  "all-properties-panel-lib": "/all-properties-panel-lib/static-1.2244",
  "crm-events-viz-timeline": "/crm-events-viz-timeline/static-1.35723",
  "customer-data-modals": "/customer-data-modals/static-1.3457",
  "merge-modal-lib": "/merge-modal-lib/static-1.6278",
  "predictive-scores-panel": "/predictive-scores-panel/static-1.24293",
  "property-history-panel": "/property-history-panel/static-1.18977",
  "flywheel-lead-visibility-lib": "/flywheel-lead-visibility-lib/static-1.429",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.3938",
  "partner-shared-messages-lib": "/partner-shared-messages-lib/static-1.12713",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2096",
  "guided-selling-core": "/guided-selling-core/static-1.4496",
  "sales-execution-components": "/sales-execution-components/static-1.7704",
  "credit-memos-highlight-card-lib": "/credit-memos-highlight-card-lib/static-1.5108",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.3872",
  "policy-lib": "/policy-lib/static-1.5457",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.22105",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.22090",
  "analytics_js": "/analytics_js/static-1.3227",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "calling-cross-tab-messaging": "/calling-cross-tab-messaging/static-1.17844",
  "feedback-schema": "/feedback-schema/static-1.48085",
  "forms-utils-lib": "/forms-utils-lib/static-1.10007",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.80515",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.4159",
  "MeetingsBase": "/MeetingsBase/static-1.54592",
  "outpost": "/outpost/static-1.3015",
  "partner-poi-timeline-event": "/partner-poi-timeline-event/static-1.34497",
  "qualified-leads-embedded-lib": "/qualified-leads-embedded-lib/static-1.42071",
  "quotes-crm-events-lib": "/quotes-crm-events-lib/static-1.37056",
  "react-table": "/react-table/static-1.15",
  "sales-clients-common": "/sales-clients-common/static-1.45107",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.5581",
  "sequences-crm-events-lib": "/sequences-crm-events-lib/static-1.22568",
  "settings-ui-nav": "/settings-ui-nav/static-2.8725",
  "social-components-lib": "/social-components-lib/static-1.28479",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.3880",
  "ui-tour-react": "/ui-tour-react/static-1.10639",
  "urlinator": "/urlinator/static-1.3219",
  "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.2523",
  "quotes-client-types": "/quotes-client-types/static-1.31047",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.2656",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.15693",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.17947",
  "viral-links-lib": "/viral-links-lib/static-1.5545",
  "media-bridge-lib": "/media-bridge-lib/static-1.16489",
  "video-data-lib": "/video-data-lib/static-1.28921",
  "FileManagerImages": "/FileManagerImages/static-1.31062",
  "trellis-story-utils": "/trellis-story-utils/static-1.3222",
  "knowledge-content-types": "/knowledge-content-types/static-1.7631",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.8605",
  "in-meeting-experience-client-types": "/in-meeting-experience-client-types/static-1.13268",
  "content-embed-lib": "/content-embed-lib/static-1.6014",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.2671",
  "remote-ui": "/remote-ui/static-1.39",
  "ui-extensions": "/ui-extensions/static-1.14484",
  "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.12077",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.1606",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.8758",
  "immutable-less": "/immutable-less/static-1.3228",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.2853",
  "markdown-it": "/markdown-it/static-1.6",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.6903",
  "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11078",
  "dashboard-lib": "/dashboard-lib/static-1.75236",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.7330",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.7522",
  "html-to-image": "/html-to-image/static-1.29",
  "reporting-plugins": "/reporting-plugins/static-1.6525",
  "reporting-reports": "/reporting-reports/static-1.60806",
  "data-token-picker": "/data-token-picker/static-1.13900",
  "navigation-messaging": "/navigation-messaging/static-1.2905",
  "attribution-lib": "/attribution-lib/static-1.37098",
  "campaigns-build-lib": "/campaigns-build-lib/static-1.7166",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.5338",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.3827",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.2414",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.6",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.5009",
  "idb-keyval": "/idb-keyval/static-1.20",
  "simple-logging-lib": "/simple-logging-lib/static-1.1703",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.7358",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.5741",
  "automation-enrollment-service-types": "/automation-enrollment-service-types/static-1.2599",
  "crm-cards-test-utils": "/crm-cards-test-utils/static-1.37395",
  "renewal-center-service-types": "/renewal-center-service-types/static-1.2835",
  "submissions-lib": "/submissions-lib/static-1.41033",
  "ui-forms-components": "/ui-forms-components/static-1.8002",
  "portal-details-components": "/portal-details-components/static-1.13519",
  "ui-extensions-plugin-flywheel": "/ui-extensions-plugin-flywheel/static-1.9018",
  "ui-product-approvals": "/ui-product-approvals/static-1.23486",
  "customer-success-client-types": "/customer-success-client-types/static-1.14254",
  "sales-enablement-lib": "/sales-enablement-lib/static-1.11404",
  "sales-leader-insights-components-lib": "/sales-leader-insights-components-lib/static-1.13031",
  "guided-actions-lib": "/guided-actions-lib/static-1.14237",
  "framework-scoring-client-types": "/framework-scoring-client-types/static-1.10969",
  "fsm": "/fsm/static-1.2377",
  "card-bet-associated-companies-lib": "/card-bet-associated-companies-lib/static-1.71248",
  "card-bet-deal-support-requests-lib": "/card-bet-deal-support-requests-lib/static-1.61989",
  "card-bet-quotes-lib": "/card-bet-quotes-lib/static-1.71255",
  "card-deal-splits-lib": "/card-deal-splits-lib/static-1.38510",
  "card-flywheel-ql-summary-lib": "/card-flywheel-ql-summary-lib/static-1.40135",
  "card-flywheel-recent-conversions-lib": "/card-flywheel-recent-conversions-lib/static-1.40136",
  "card-invoices-lib": "/card-invoices-lib/static-1.50639",
  "card-marketing-event-about-lib": "/card-marketing-event-about-lib/static-1.50421",
  "card-marketing-event-activity-lib": "/card-marketing-event-activity-lib/static-1.50420",
  "card-past-feedback-lib": "/card-past-feedback-lib/static-1.36241",
  "card-prospecting-notes": "/card-prospecting-notes/static-1.32497",
  "card-qualified-leads-lib": "/card-qualified-leads-lib/static-1.71410",
  "card-sfdcsync-lib": "/card-sfdcsync-lib/static-1.50491",
  "card-workflows-lib": "/card-workflows-lib/static-1.67423",
  "integrations-sync-card-ui": "/integrations-sync-card-ui/static-1.21435",
  "partner-poi-crm-card": "/partner-poi-crm-card/static-1.13953",
  "recording-preview-card": "/recording-preview-card/static-1.11342",
  "ui-sales-order-wizard-card": "/ui-sales-order-wizard-card/static-1.26424",
  "predictive-scores-lib-components": "/predictive-scores-lib-components/static-1.22688",
  "process-guide-chirp": "/process-guide-chirp/static-1.3264",
  "gapi-client-types": "/gapi-client-types/static-1.3",
  "google-picker-types": "/google-picker-types/static-1.3",
  "ui-google-drive-picker": "/ui-google-drive-picker/static-1.973",
  "deep-diff": "/deep-diff/static-1.5",
  "academy-service-client": "/academy-service-client/static-1.2688",
  "zustand": "/zustand/static-1.51",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.13572",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.7787",
  "cms-field-types": "/cms-field-types/static-1.3457",
  "content-icons-ui": "/content-icons-ui/static-1.1867",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.6885",
  "fintech-buying-service-clients": "/fintech-buying-service-clients/static-1.2375",
  "account-and-billing-contacts-usage": "/account-and-billing-contacts-usage/static-2.17654",
  "emoji-regex": "/emoji-regex/static-1.7",
  "signup-ui-full-screen-search": "/signup-ui-full-screen-search/static-1.10054",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.2735",
  "buying-experience-components": "/buying-experience-components/static-1.8468",
  "checkout-service-types": "/checkout-service-types/static-1.2823",
  "growth-pro-utils-lib": "/growth-pro-utils-lib/static-1.7804",
  "audio-components": "/audio-components/static-1.4296",
  "video-components": "/video-components/static-1.7273",
  "video-embed": "/video-embed/static-1.29762",
  "conversations-calling-message": "/conversations-calling-message/static-1.54094",
  "crm-events-viz-test-utils": "/crm-events-viz-test-utils/static-1.16680",
  "crm-pipeline-events-ui": "/crm-pipeline-events-ui/static-1.22128",
  "conversations-routing-lib": "/conversations-routing-lib/static-1.5748",
  "conversations-visibility-tools": "/conversations-visibility-tools/static-1.4422",
  "data-ops-fullstory": "/data-ops-fullstory/static-1.4012",
  "re-reselect": "/re-reselect/static-1.4",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.6715",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.4549",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.4546",
  "ql-visibility-lib": "/ql-visibility-lib/static-1.4171",
  "automation-ui-core": "/automation-ui-core/static-2.15361",
  "automation-ui-permissions": "/automation-ui-permissions/static-1.13723",
  "workspace-components": "/workspace-components/static-1.2701",
  "workspace-view-data": "/workspace-view-data/static-1.1276",
  "settings-content-modals": "/settings-content-modals/static-1.39402",
  "forms-ai-lib": "/forms-ai-lib/static-1.2078",
  "react-tinymce": "/react-tinymce/static-1.50079",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1298",
  "tinymce-config": "/tinymce-config/static-2.49205",
  "meetings-client-types": "/meetings-client-types/static-1.2680",
  "messaging-types-lib": "/messaging-types-lib/static-1.39770",
  "apps-service-types": "/apps-service-types/static-1.2816",
  "oauth-service-types": "/oauth-service-types/static-1.2960",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6580",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.2326",
  "stripe-connect-js": "/stripe-connect-js/static-1.37",
  "customer-data-sidebar-test-utils": "/customer-data-sidebar-test-utils/static-1.35094",
  "form-builder-ui": "/form-builder-ui/static-1.7761",
  "user-configuration-lib": "/user-configuration-lib/static-1.24142",
  "ui-deal-management-components-lib": "/ui-deal-management-components-lib/static-1.15272",
  "ui-signature-editor": "/ui-signature-editor/static-1.13360",
  "immerable": "/immerable/static-1.2825",
  "social-insights-client-types": "/social-insights-client-types/static-1.17384",
  "automation-ui-routing": "/automation-ui-routing/static-1.14785",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.12507",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.2931",
  "access-control-lib": "/access-control-lib/static-1.9124",
  "EmailComponents": "/EmailComponents/static-1.48463",
  "EmailData": "/EmailData/static-1.47139",
  "redux-less": "/redux-less/static-2.8113",
  "tinymce-themes": "/tinymce-themes/static-1.51175",
  "interframe": "/interframe/static-3.3471",
  "tinymce-data": "/tinymce-data/static-1.35290",
  "tinymce-plugins": "/tinymce-plugins/static-1.52319",
  "ContentData": "/ContentData/static-1.62757",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1414",
  "layout-dnd-components": "/layout-dnd-components/static-1.10599",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.9574",
  "app-users-service-client": "/app-users-service-client/static-1.3719",
  "app-users-service-types": "/app-users-service-types/static-1.3125",
  "framework-listing-lib": "/framework-listing-lib/static-2.21892",
  "mini-checkout-client": "/mini-checkout-client/static-1.23904",
  "onboarding-utils": "/onboarding-utils/static-1.4027",
  "ContentComponents": "/ContentComponents/static-2.65638",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.40034",
  "ui-tool-access": "/ui-tool-access/static-1.8723",
  "automation-ui-types": "/automation-ui-types/static-1.13425",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8117",
  "codemirror": "/codemirror/static-5.69",
  "react-codemirror": "/react-codemirror/static-1.9278",
  "layout-data-lib": "/layout-data-lib/static-1.7899",
  "framework-listing-lib-shared-msw-handlers": "/framework-listing-lib-shared-msw-handlers/static-1.6796",
  "touchless-buying-components": "/touchless-buying-components/static-1.3122",
  "merchandise-lib": "/merchandise-lib/static-1.223",
  "data-token-views": "/data-token-views/static-1.13881",
  "simple-menus-core": "/simple-menus-core/static-1.13395",
  "simple-menus-lib": "/simple-menus-lib/static-1.14912",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.27827",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.4787",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.2462",
  "ContentEditorUI": "/ContentEditorUI/static-2.71086",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.2815",
  "web-interactives-components": "/web-interactives-components/static-1.11296",
  "web-interactives-data": "/web-interactives-data/static-1.11297",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "checkout-sdk": "/checkout-sdk/static-3.20747",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.2550",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "backbone": "/backbone/static-1.6",
  "content-management-data-lib": "/content-management-data-lib/static-1.3733",
  "copilot-plugins": "/copilot-plugins/static-1.5732",
  "cta-picker": "/cta-picker/static-1.30863",
  "editor-components": "/editor-components/static-1.11681",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.6981",
  "error-messaging-js": "/error-messaging-js/static-1.3965",
  "pictos": "/pictos/static-7.159",
  "redux-request-state": "/redux-request-state/static-1.9252",
  "smart-content-core": "/smart-content-core/static-1.36806",
  "smart-content-lib": "/smart-content-lib/static-1.37459",
  "social-composer-lib": "/social-composer-lib/static-1.52896",
  "structured-content-lib": "/structured-content-lib/static-1.19719",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.47406",
  "tinymce-copilot": "/tinymce-copilot/static-1.11273",
  "ui-active-theme-content-creator-lib": "/ui-active-theme-content-creator-lib/static-1.31326",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.5762",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.606",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "jquery": "/jquery/static-3.6",
  "ai-rendering-library": "/ai-rendering-library/static-1.4557",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.7991",
  "fuzzy": "/fuzzy/static-1.8",
  "codemirror-dlb": "/codemirror-dlb/static-1.52640",
  "redux-undo": "/redux-undo/static-1.10",
  "highlight.js": "/highlight.js/static-1.45"
}
};
